/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Contract_Seats_HintInputs */



/**
* | output |
* | --- |
* | "Billed every period regardless of how many people actually join." |
*
* @param {Partner_Add_Contract_Seats_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_contract_seats_hint = /** @type {((inputs?: Partner_Add_Contract_Seats_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Contract_Seats_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird in jeder Periode abgerechnet, unabhängig davon, wie viele Personen tatsächlich beitreten.")
	return /** @type {LocalizedString} */ ("Billed every period regardless of how many people actually join.")
});